/**
 * Created by JackCui on 2021/12/16
 */

export const buttonsSchemaHandle = {
  handle (node, {objectApiName, layoutApiName, config}) {
    const {props} = node
    node.objectApiName = objectApiName
    node.layoutApiName = layoutApiName
    return {
      slots: config?.table?.slots || {},
      props: {
        ...props,
        span: '0'
      }
    }
  }
}

export const buttonsProps = {
  buttons: {
    type: Array,
    default () {
      return []
    }
  },
  position: {
    type: String,
    default: 'horizontal'
  },
  maxLength: Number,
  size: String,
  row: Object
}

// event
// button-click(btn)
